import React from 'react'
import styled from 'styled-components'
import { Link } from '@nv/react-akira'
import { Link as RouterLink } from 'react-router-dom'
import { ROUTES } from 'containers/Base/constants'
import { FormattedMessage } from 'react-intl'
import { AKIRA_QUERIES } from 'themes'
import { MaintenanceWarning } from 'components/MaintenanceWarning'
import { useMaintenanceWarning } from 'hooks/useMaintenanceWarning'

export const Header = () => {
  const { maintenanceString } = useMaintenanceWarning()

  return (
    <Wrapper>
      {!!maintenanceString && <MaintenanceWarning maintenanceString={maintenanceString} />}
      <Heading>
        <FormattedMessage id='auth.welcome_back' />
      </Heading>
      <SignUpTextWrapper>
        <Text>
          <FormattedMessage id='auth.dont_have_an_account' />
        </Text>
        <Link as={RouterLink} to={ROUTES.UNIFIED_SIGNUP}>
          <FormattedMessage id='auth.sign_up_here' />
        </Link>
      </SignUpTextWrapper>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  margin-bottom: 20px;

  @media ${AKIRA_QUERIES.laptopAndUp} {
    margin-bottom: 28px;
  }
`

const Heading = styled.h1`
  && {
    margin-bottom: 8px;
    font-size: 20px;
    font-weight: bold;
    line-height: inherit;
    color: inherit;
  }
`

const Text = styled.span`
  font-size: 14px;
  color: inherit;
  font-weight: 400;
`

const SignUpTextWrapper = styled.div`
  display: flex;
  gap: 4px;
`
